<template>
  <!-- 平台协议 -->
  <div class="person">
    <el-tabs v-model="activeName">
      <el-tab-pane label="用户协议" name="first">
        <div class="word">
          <div v-html="ratetitle"></div>
          <div v-html="ratetext"></div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="隐私政策" name="second">
        <div class="word">
          <div v-html="yinsititle"></div>
          <div v-html="yinsitext"></div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
    
<script>
import { indexPolicy } from "@/api/api";
// import axios from 'axios';
export default {
  components: {},
  data() {
    return {
      activeName: "first",
      ratetitle:'',
      ratetext:'',
      yinsititle:'',
      yinsitext:'',
    };
  },
  methods: {
    // 
    async getindexPolicy(){
      try {
        const res = await indexPolicy({type:'service'});
        // const res = await axios.get('https://dhctest.yunfangshi.com/api/index/policy?type=service')
        this.ratetitle = this.showHtml(res.data.title);
        this.ratetext = this.showHtml(res.data.content);
      } catch (error) {
        console.log(error, "获取平台协议失败");
      }
    },
    async getYinSiPolicy(){
      try {
        const res = await indexPolicy({type:'privacy'});
        // const res = await axios.get('https://dhctest.yunfangshi.com/api/index/policy?type=service')
        this.yinsititle = this.showHtml(res.data.title);
        this.yinsitext = this.showHtml(res.data.content);
      } catch (error) {
        console.log(error, "获取失败");
      }
    },
    // 富文本处理
    showHtml(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    },
  },
  mounted(){
    // 获取平台协议
    this.getindexPolicy();
    // 隐私政策
    this.getYinSiPolicy();
  }
};
</script>
    
<style style lang="scss" scoped>
.person {
  padding: 24px 32px 32px 32px;

  .word{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    font-style: normal;
    text-transform: none;
  }
}
::v-deep .el-tabs__item.is-active {
  color: #0073f5; //选中
}

::v-deep .el-tabs__item:hover {
  color: #0073f5; //hover
  // cursor: pointer;
}
// 普通字体颜色
::v-deep .el-tabs__item {
  color: #606260; //悬浮
  // cursor: pointer;
  font-size: 18px;
}

// 下划线颜色
::v-deep .el-tabs__active-bar {
  background-color: #0073f5;
}
</style>